const NS = 'ProgramCoursesListWidget';
const CLS = 'programCoursesListWidget';

export class ProgramCoursesListWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$filterButtons = this.$element.find(`.${CLS}-filters-button`);
		this.$filterButtons.on('click', (event) => {
			this.$filterButtons.removeClass(`${CLS}-filters-button--active`);
			$(event.currentTarget).addClass(`${CLS}-filters-button--active`);

			let $courses = this.$element.find(`.programCoursesItemWidget`);

			if($(event.currentTarget).hasClass(`${CLS}-filters-button--inProgress`)) {
				$courses.each((index, element) => {
					let $course = $(element);
					if(!$course.hasClass(`programCoursesItemWidget--inProgress`)) {
						$course.css({
							display: 'none'
						});
					}
				});
			}
			else {
				$courses.each((index, element) => {
					let $course = $(element);
					$course.css({
						display: 'block'
					});
				});
			}
		});
	}
}
